import React from 'react';
import { useHistory } from 'react-router-dom';

export interface BackButtonProps {
    applicationBack?: () => void;
    showIcon?: boolean;
    children?: React.ReactNode;
}
export function BackButton({ applicationBack, showIcon = true, children }: BackButtonProps) {
    const history = useHistory();
    return (
        <button
            onClick={applicationBack || history.goBack}
            title="Click to go back"
            className="back-button link-button"
            type="button"
        >
            {showIcon && <i className="fa-solid fa-arrow-circle-left" />}
            {children}
        </button>
    );
}
